import { CommunityMarkdown } from "@softmax/web-ux/prose";
import { communityNavigation } from "@softmax/web-features/community";
export function RulesMarkdown({
  body,
  basePath,
}: {
  body: string;
  basePath: string;
}) {
  const navigation = communityNavigation({ basePath });
  return (
    <CommunityMarkdown
      body={body}
      wikiPageHref={navigation.wikiPageHref}
      demoteHeadings
      renderLink={({ href, children, ...props }) =>
        href === basePath || href.startsWith(`${basePath}/`) ? (
          <span>{children}</span>
        ) : (
          <a href={href} {...props}>
            {children}
          </a>
        )
      }
    />
  );
}
